
import axios from 'axios';
var _API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiRGV2ZWxvcG1lbnQgdG9rZW4iLCJwbGF0Zm9ybSI6ImRldiIsImFwcCI6IkRldmVsb3BtZW50In0.QXkohQ7lHeuS71xdcQJWa9_krUjtxFI4s1BqF1FkvW0';

const getNotifications = (context) => {

    if (context.rootState.social.user) {
    
        context.commit('SET_NOTIFICATIONS_LOADING', true);
        axios
            .get(
                'https://api.agroclimate.org/v2/notification/notifications/app/test/user/' + context.rootState.social.user._id, {
                //'http://127.0.0.1:5000/notifications/app/indicators/user/' + context.rootState.social.user._id , {
                    headers: { 'x-api-key': _API_KEY }
                }
            )
            .then(response => {
                if (response.data.code == 'SUCCESS')
                    context.commit('SET_NOTIFICATIONS', response.data.data);
                context.commit('SET_NOTIFICATIONS_LOADING', false);
            })
            .catch(e => {
                console.log(e);
            });
    }
};


const createNotification = (context, notification) => {

    context.commit('SET_NOTIFICATIONS_CREATING', { status: true,  data: {}});
    axios({
        method: 'post',
        url: 'https://api.agroclimate.org/v2/notification/notification',
        headers: { 
            'x-api-key': _API_KEY,
            'Authorization': 'Bearer ' + sessionStorage.getItem('user-jwt')
        },
        data: notification
      }).then(response => {
        context.commit('SET_NOTIFICATIONS_CREATING', { status: false,  data: response.data });
        console.log('onCreate vws: ', response)
    })
    .catch(e => {
        context.commit('SET_NOTIFICATIONS_CREATING', { status: false,  data: {code: 'ERROR', message: ''} });
        console.log(e);
    });

};

const setViewNotificationsManager = (context, status) => {
    context.commit('SET_VIEW_NOTIFICATIONS_MANAGER', status);
}

const resetNotificationsCreating = (context) => {
    context.commit('SET_NOTIFICATIONS_CREATING', { status: false,  data: {}});
}

export default {
    getNotifications,
    createNotification,
    resetNotificationsCreating,
    setViewNotificationsManager,
};